import LogoPNG from '../../assets/quantum/IYQST-horiz-rgb.png';

export const Logo = () => {
  return (
    <div className="snn-top-menu-logo-wrapper">
      <img
          src={LogoPNG}
        alt="Symposium of Nanoscience and Nanotechnology Logo"
        className="snn-top-menu-logo"
      />
    </div>
  );
};
